import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')

// マスタデータ
export const conditionSearch = (page, div, type) => {
    let querys = querystring.stringify({ type: type })
    return http.requestQuickGet(apiUrl.apiurl_masterData + '/' + page + '/' + div + '?' + querys)
}

// 給与振込口座申請検索
export const salaryAccountInfoGet = (userCd) => {
    return http.requestGet(apiUrl.apiUrl_SalaryAccountInfo + '?userCd=' + userCd)
}

// 銀行検索
export const bankInfoGet = (bankName) => {
    return http.requestGet(apiUrl.apiUrl_BankInfo + '?bankName=' + encodeURIComponent(bankName) + '&page=1&size=2000')
}

// 支店検索
export const branchInfoGet = (bankCd, branchName) => {
    return http.requestGet(apiUrl.apiUrl_BranchInfo + '?bankCd=' + bankCd + '&branchName=' + encodeURIComponent(branchName)+ '&page=1&size=2000')
}

// 給与振込口座申請更新
export const salaryAccountInfoSave = (params, userCd) => {
    return http.requestPost(apiUrl.apiUrl_SalaryAccountInfo + '?userCd=' + userCd, params)
}


// WEBPACK FOOTER //
// ./src/module/api/i_0003.js